export default [
    {
        path: 'tag/list',
        name: 'content_tag_list',
        meta: { isCache: true, icon: 'md-pricetags', hideInMenu: false },
        component: () => import('@/views/content/tag/tag-list.vue'),
    },
    {
        path: 'tag/add',
        name: 'content_tag_add',
        meta: { isCache: true, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/content/tag/tag-add.vue'),
    },
    {
        path: 'tag/edit/:id',
        name: 'content_tag_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/content/tag/tag-edit.vue'),
    },
    {
        path: 'tag/detail/:id',
        name: 'content_tag_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/content/tag/tag-detail.vue'),
    },
];
